import * as React from 'react'
import parse, {
  attributesToProps,
  Element,
  HTMLReactParserOptions,
  domToReact
} from 'html-react-parser'
import styles from './index.module.scss'
import clsx from 'clsx'
import { getAppConfig } from '@/projects/feedback/utils/CONST'
import { purchaseLinkParams, reportFn } from '@feedback/utils/util'

interface RichTextParserProps {
  html: string
}

const options: HTMLReactParserOptions = {
  replace: (domNode) => {
    const typedDomNode = domNode as Element

    if (typedDomNode.attribs && typedDomNode.name === 'a') {
      const aProps = attributesToProps(typedDomNode.attribs)
      const newURL = purchaseLinkParams(aProps.href, {
        entry_type: '1'
      })
      return (
        <a
          {...aProps}
          href={newURL}
          onClick={() => {
            reportFn({ parm1: 6, parm2: 4, parm6: '' })
          }}
        >
          {domToReact(typedDomNode.children)}
        </a>
      )
    }

    return false
  }
}

const RichTextParser: React.FC<RichTextParserProps> = ({ html }) => {
  const { appid } = getAppConfig() || {}

  return (
    <div className={clsx(styles?.['rich-text'], styles?.[appid])}>
      {parse(html, options)}
    </div>
  )
}

export default RichTextParser
